// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useMemo, useState } from 'react'
import { PrimaryButton } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import plusIcon from '../../../images/management/clinicMembers/plusIcon.png'
import { setVisitError } from '../../../store/visits/VisitsActions'
import './AddVisitRemark.scss'

const primaryBtnLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  fontSize: 18,
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const AddVisitRemark = memo(({ inputValue, onChangeInputValue, addPressCallback, addSidePanelItemInputRef }) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const visitRemarks = useSelector((state) => state.visitsReducer.visitRemarks)

  const [simpleText, setSimpleText] = useState('')
  const [isErrorField, setIsErrorField] = useState('')
  const [isNewRemarkInInputFocus, setIsNewRemarkInputInFocus] = useState(false)
  const primaryBtnContainerStyle = useMemo(
    () => ({
      whiteSpace: 'nowrap',
      width: 84,
      height: 40,
      position: 'absolute',
      right: 4,
      bottom: isErrorField ? 30 : 4,
    }),
    [isErrorField],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onPressAddBtn = (e) => {
    if (simpleText.trim().length) {
      addPressCallback(e)
    } else {
      setIsErrorField(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Type new remark'))

      dispatch(setVisitError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
    }
  }

  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const handleEnterPressEvent = (e) => {
      if (e.key === 'Enter' && !e.shiftKey && !e.altKey && !e.metaKey && !e.ctrlKey && isNewRemarkInInputFocus) {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        onPressAddBtn()
      }
    }
    window.addEventListener('keyup', handleEnterPressEvent)
    return () => window.removeEventListener('keyup', handleEnterPressEvent)
  }, [simpleText, isNewRemarkInInputFocus])

  useEffect(() => {
    const input = document.getElementById('addNewRemarkTextField')
    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    input.addEventListener('paste', (e) => {
      e.preventDefault()
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const text = e.clipboardData.getData('text/plain')
      document.execCommand('insertText', false, text)
    })
  }, [])

  useEffect(() => {
    setIsErrorField('')
    dispatch(setVisitError(''))
    setSimpleText('')
  }, [visitRemarks])

  useEffect(() => {
    // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
    setSimpleText(document.getElementById('addNewRemarkTextField').innerText)
    if (isErrorField.length) {
      setIsErrorField('')
      dispatch(setVisitError(''))
    }
  }, [inputValue])

  const waitingRoomStyleBorder = useMemo(
    () => ({ border: isErrorField ? '1px solid #d93603' : '1px solid #00A2B2' }),
    [isErrorField],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleNewRemarkInputInFocus = (isInFocus) => () => {
    if (isInFocus) {
      setIsNewRemarkInputInFocus(true)
    } else {
      setIsNewRemarkInputInFocus(false)
    }
  }

  return (
    <div className='add-new-remark-block'>
      <div className='add-new-remark-tool-container' style={waitingRoomStyleBorder}>
        <div
          ref={addSidePanelItemInputRef}
          data-placeholder='Type new remark'
          className='add-new-remark-input'
          role='input'
          id='addNewRemarkTextField'
          onFocus={toggleNewRemarkInputInFocus(true)}
          onBlur={toggleNewRemarkInputInFocus(false)}
          onInput={onChangeInputValue}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          value={inputValue}
          contentEditable
        />
        <PrimaryButton
          btnText={
            <>
              <img alt='AddIcon' src={plusIcon} className='patient-side-add-img' />
              Add
            </>
          }
          onPress={onPressAddBtn}
          labelStyle={primaryBtnLabelStyle}
          containerStyle={primaryBtnContainerStyle}
        />
      </div>
      <div className='add-new-visit-remark-error'>{isErrorField}</div>
    </div>
  )
})
